import { type LinkedBankAccountConstructor } from '../../entities/LinkedBankAccount'
import { type LinkedBankAccountApiModel } from '../api-models/LinkedBankAccountApiModel'

export const mapLinkedBankAccountApiModel = (
  data: LinkedBankAccountApiModel
): LinkedBankAccountConstructor => ({
  id: data.id,
  uuid: data.uuid,
  bankName: data.bank_name,
  accountName: data.account_name,
  accountMask: data.account_mask,
  status: data.status,
  glCode: data.gl_code,
})
